import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminGenerators from "@/pages/admin/AdminGenerators";

export const Route = createFileRoute("/admin/generators/")({
  component: () => (
    <ProtectedRoute>
      <AdminGenerators />
    </ProtectedRoute>
  ),
});
